import service from "./axiosConfig";
// 获取指导老师列表
export const getTeacherList = () => {
  return service.get("/interface/teachers/teacherslist");
};
